export function encodeParams(selectedFilterObject: any): string {
  try {
    return window.btoa(JSON.stringify(selectedFilterObject));
  } catch (error) {
    return "";
  }
}
